module.exports = __WEBPACK_EXTERNAL_MODULE__0__;


// WEBPACK FOOTER //
// webpack:/CKEditor/external {"commonjs":"vue","commonjs2":"vue","amd":"vue","root":"Vue"}